const requireContext = require.context( '../../', true, CONTEXT_REGEX_FRONTEND );
requireContext.keys().forEach( key => requireContext( key ) );
